import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';

import {
  ClientDetailsModel,
  ClientListRequestModel,
  ClientListResponseModel,
  ClientProfilePictureModel,
  CreateClientRequestModel,
  UpdateClientDetailsRequestModel,
} from '../../model';

@Injectable({
  providedIn: 'root',
})
export class AccountClientService {
  constructor(private http: HttpClient) {}

  public createClient(body: CreateClientRequestModel): Observable<HttpResponse<void>> {
    return this.http.post<void>(`${environment.apiEndpoint}/account/client`, body, { observe: 'response' });
  }

  public getClientProfilePictures(clientIds: string[]): Observable<ClientProfilePictureModel[]> {
    const params: HttpParams = new HttpParams().set('ids', clientIds.join(','));
    return this.http.get<ClientProfilePictureModel[]>(`${environment.apiEndpoint}/account/client/profile-pictures`, {
      params,
    });
  }

  public getClientList(clientListRequestModel: ClientListRequestModel): Observable<ClientListResponseModel> {
    let params: HttpParams = new HttpParams();

    if (clientListRequestModel?.page) {
      params = params.set('page', clientListRequestModel.page);
    }
    if (clientListRequestModel?.page_size) {
      params = params.set('page_size', clientListRequestModel.page_size);
    }
    if (clientListRequestModel?.query) {
      params = params.set('query', clientListRequestModel.query);
    }
    if (clientListRequestModel?.sort_field) {
      params = params.set('sort_field', clientListRequestModel.sort_field);
    }
    if (clientListRequestModel?.sort_direction) {
      params = params.set('sort_direction', clientListRequestModel.sort_direction);
    }
    if (clientListRequestModel?.filter_main_advisor) {
      params = params.set('filter_main_advisor', clientListRequestModel.filter_main_advisor);
    }
    if (clientListRequestModel?.filter_consent_accepted || clientListRequestModel?.filter_consent_accepted === false) {
      params = params.set('filter_consent_accepted', clientListRequestModel.filter_consent_accepted);
    }
    if (clientListRequestModel?.filter_mandate_state) {
      params = params.set('filter_mandate_state', clientListRequestModel.filter_mandate_state);
    }
    if (clientListRequestModel?.filter_mvp_connected) {
      params = params.set('filter_mvp_connected', clientListRequestModel.filter_mvp_connected);
    }
    if (clientListRequestModel?.filter_analysis) {
      params = params.set('filter_analysis', clientListRequestModel.filter_analysis);
    }
    if (clientListRequestModel?.filter_potential) {
      params = params.set('filter_potential', clientListRequestModel.filter_potential);
    }
    if (
      clientListRequestModel?.filter_financial_profile_completed ||
      clientListRequestModel?.filter_financial_profile_completed === false
    ) {
      params = params.set(
        'filter_financial_profile_completed',
        clientListRequestModel.filter_financial_profile_completed,
      );
    }
    if (clientListRequestModel?.filter_client_ids) {
      params = params.set('filter_client_ids', clientListRequestModel.filter_client_ids);
    }
    if (clientListRequestModel?.exclude_placeholder_emails) {
      params = params.set('exclude_placeholder_emails', clientListRequestModel.exclude_placeholder_emails);
    }

    return this.http.get<ClientListResponseModel>(`${environment.apiEndpoint}/account/client`, { params });
  }

  public getClientDetails(clientId: string): Observable<ClientDetailsModel> {
    return this.http.get<ClientDetailsModel>(`${environment.apiEndpoint}/account/client/${clientId}`);
  }

  public updateClientDetails(clientId: string, body: UpdateClientDetailsRequestModel): Observable<void> {
    return this.http.put<void>(`${environment.apiEndpoint}/account/client/${clientId}`, body);
  }

  public deleteClient(clientId: string): Observable<void> {
    return this.http.delete<void>(`${environment.apiEndpoint}/account/client/${clientId}`);
  }

  public reassignMainAdvisorForClient(clientId: string, advisorId: string): Observable<void> {
    return this.http.put<void>(`${environment.apiEndpoint}/account/client/${clientId}/main-advisor/${advisorId}`, null);
  }

  public updateExternalMandate(clientId: string, externalMandate: boolean): Observable<void> {
    return this.http.put<void>(
      `${environment.apiEndpoint}/account/client/${clientId}/external-mandate?external_mandate=${externalMandate}`,
      null,
    );
  }
}
